import React from 'react';
import { List, Filter, Edit, Create, Datagrid, SimpleForm, required,
		TextField, BooleanField, UrlField, DateField, ReferenceField,
		TextInput, BooleanInput, DateInput, NumberInput, SelectInput, ReferenceInput, LongTextInput, DisabledInput,
		EditButton, DeleteButton  } from 'admin-on-rest';
import { CardActions } from 'material-ui/Card';
import { RefreshButton } from 'admin-on-rest';
import IpColumnField from './IpColumnField';
import UserAgentColumnField from './UserAgentColumnField';
import ExportClicksButton from './ExportClicksButton';
import SiteclickSummary from './SiteclickSummary';
import TeltMeeField from '../utils/TeltMeeField';
import CHBoolField from '../utils/CHBoolField';
import CHEurField from '../utils/CHEurField';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const ClicksActions = ({ resource, filters, displayedFilters, filterValues, basePath, showFilter }) => (
    <div>
        <CardActions style={cardActionStyle}>
            {filters && React.cloneElement(filters, { resource, showFilter, displayedFilters, filterValues, context: 'button' }) }
            <RefreshButton />
            <ExportClicksButton filterValues={filterValues} />
        </CardActions>
        <SiteclickSummary filterValues={filterValues} />
    </div>
);

const GridFilters = (props) => (
    <Filter {...props}>
		<ReferenceInput label="Adverteerder" source="user_id" linkType={false} reference="admin/customers" alwaysOn>
            <SelectInput optionText="company_name" />
        </ReferenceInput>
		<ReferenceInput label="Cloudhints site" source="cloudhintsdomains_id" linkType={false} reference="admin/cloudhintsdomains" alwaysOn>
            <SelectInput optionText="title" />
        </ReferenceInput>
		
		<DateInput source="to_date" label="Tot en met datum" alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een t/m datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl'
			}} />
			
		<DateInput source="from_date" label="Van datum" alwaysOn options={{
				mode: 'portrait',
				hintText: 'Kies een van datum',
				okLabel: 'OK',
				cancelLabel: 'Cancel',
				locale: 'nl',
			}} />
					
    </Filter>
);

export const SiteclickList = (props) => (
    <List title="Clicks (laatste 200)" perPage={200} filters={<GridFilters />} actions={<ClicksActions />} {...props}>
        <Datagrid >
			
			<DateField source="clickdatetime" sortable={false} showTime />
            <IpColumnField source="user_ip" sortable={false} />
            <UserAgentColumnField source="user_agent" sortable={false} />
            <TextField source="link_key" sortable={false} />
            <TextField source="link_url" sortable={false} />
            <TextField source="link_description" sortable={false} />
            <TextField source="title" label="Domain" sortable={false} />
            <CHEurField source="clickcost" label="CPC" sortable={false} />
            <TeltMeeField label="Telt mee" sortable={false} />
            <CHBoolField source="suspectedcrawler" label="Crawler" sortable={false} />
            <CHBoolField source="blacklistedip" label="IP/UA geblokkeerd" sortable={false} />
            <CHBoolField source="blacklist_startswith" label="IP-range" sortable={false} />
            <CHBoolField source="blacklist_ai" label="Bot-gedrag" sortable={false} />
            <CHBoolField source="filtereddoubles" label="Dubbel" sortable={false} />

			<EditButton />
			<DeleteButton />
			
		</Datagrid>
    </List>
);


export const SiteclickEdit = (props) => (
    <Edit title="Edit" {...props}>
        <SimpleForm>
           	<DisabledInput source="outgoinglink_raw" />
           	<DisabledInput source="user_agent" />
           	<DisabledInput source="user_ip" />

			<br/><br/>
			<strong>Crawler / blacklist? </strong>
			<BooleanInput source="blacklistedip" />
			<BooleanInput source="blacklist_startswith" />
			<BooleanInput source="suspectedcrawler" />	
			<BooleanInput source="blacklist_ai" />	
			<BooleanInput source="filtereddoubles" />	
			
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/siteclicks/Siteclicks.js